const STEPS = ["Ask", "Magic word", "Heard", "Gratitude", "Done"];

export const Stepper = ({ step }) => (
  <ol className="pp-stepper" data-testid="flow-stepper">
    {STEPS.map((s, i) => (
      <li key={s} className={i < step ? "done" : i === step ? "now" : ""} data-testid={`step-${i}`}>
        <span className="dot">{i + 1}</span>
        <span className="lbl">{s}</span>
      </li>
    ))}
  </ol>
);
